import { asyncType } from '../types';

export const FIREBASE_GOOGLE_LOGIN_POPUP = asyncType('GOOGLE_POPUP');
export const FIREBASE_LOGIN_REDIRECT = asyncType('LOGIN_REDIRECT');
export const TRIGGER_LOGIN_WITH_REDIRECT = asyncType(
  'TRIGGER_LOGIN_WITH_REDIRECT',
);
export const GET_LOGIN_REDIRECT_RESULT = asyncType('GET_LOGIN_REDIRECT_RESULT');
